import React from "react";
import { Text, Flex, Circle, type FlexProps } from "@chakra-ui/react";

export function Tooltip({ color, children, ...props }: { color: string } & FlexProps) {
  return (
    <Flex
      align="center"
      bg="white"
      borderRadius="smallest"
      boxShadow="lg"
      gap={{ base: "tiny", lg: "smallest" }}
      justify="center"
      py="tinier"
      px={{ base: 2, lg: 3, xl: 4 }}
      h={{ base: "32px", lg: "36px" }}
      {...props}
    >
      <Circle bg={color} size="12px" />
      <Text textStyle={{ base: "caption2", lg: "caption1" }} fontWeight="semibold">
        {children}
      </Text>
    </Flex>
  );
}
